import React from 'react';
import './ExpertContactMessage.css';

const ExpertContactMessage: React.FC = () => {
  return (
    <div className="expert-contact-message">
      <p className="expert-contact-text">
        Complex situation? Get personalized advice from our experts by contacting{' '}
        <a href="mailto:info@soundlegal.ai" className="expert-contact-link">
          info@soundlegal.ai
        </a>
      </p>
    </div>
  );
};

export default ExpertContactMessage;
